<script setup lang="ts">
import { AppButton, AppSvgIcon } from '@libs/ui';

interface PaxSelectorButtonProps {
  buttonText: string;
}

const props = defineProps<PaxSelectorButtonProps>();

interface PaxSelectorButtonEmits {
  (eventName: 'click'): void;
}

const emit = defineEmits<PaxSelectorButtonEmits>();
</script>

<template>
  <AppButton
    type="secondary"
    state="enabled"
    size="small"
    :icon="{
      size: '18',
      name: 'chevronDown',
      position: 'left',
    }"
    @click="emit('click')"
  >
    <div class="pax-selector-button">
      <AppSvgIcon name="peopleOutlined" size="18" />
      {{ props.buttonText }}
    </div>
  </AppButton>
</template>

<style scoped lang="scss">
.pax-selector-button {
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
}
</style>
